import React from "react";
import { Spinner, SpinnerProps } from "@components/ui/shadcn-io/spinner";
import { cn } from "@lib/utils";

/**
 * SpinnerContainer is a React functional component used to render a spinner
 * centered within a container. The component adjusts its size and appearance
 * based on the provided props.
 *
 * @param {SpinnerProps} props - The properties passed to the SpinnerContainer component.
 * It includes all properties supported by the Spinner component and an additional
 * className for custom styling.
 *
 */
export const SpinnerContainer = (props: SpinnerProps) => (
  <div className={cn("flex h-1/2 w-full items-center justify-center", props.className)}>
    <Spinner width={50} height={50} variant="ring" {...props} />
  </div>
);
